import { map, filter } from 'lodash';
import { authLogout } from 'logic/auth';
import { memberStorage } from 'utils';
import { PROFILE_CANCELLATION_REASONS, UPGRADE_TEXT } from '../constants';

import {
  fetchMember,
  fetchInvoices,
  cancelSubscription,
  downgradeSubscription,
  resumeSubscription,
  selectHasNutritionSubscription,
  selectHasWorkoutSubscription,
  selectMember,
  selectNutritionQuestions,
  selectSubscription,
  selectSubscriptions,
  selectWorkoutQuestions,
  updateMember,
  updateMemberField,
  updateMemberPassword,
} from 'logic/member';

import {
  checkStatus,
  reset,
  setup,
  selectProduct,
  updateChargifyData,
} from 'logic/signup';

export const Profile = {
  template: `
    <div class="profile">
      <main class="main-content theme-mid">
        <div class="container">
          <section class="profile-content row py-4">
            <div class="position-relative w-100">
              <div class="avatar avatar--md theme-avatar-circle">
                <image-circle src="$ctrl.member.profile.avatarUrl.original">
                </image-circle>
              </div>
              <div class="profile-containers theme-light p-3">
                <div class="mb-3">
                <h1>{{$ctrl.member.error}}</h1>
                  <profile-container
                    on-click="$ctrl.onToggleEditing(0)"
                    is-editing="$ctrl.isEditing[0]">
                    <form class="pt-5 pb-3"
                      name="fieldsForm"
                      ng-submit="$ctrl.onSubmit()"
                      novalidate>
                      <profile-fields
                        form="fieldsForm"
                        member="$ctrl.member"
                        is-editing="$ctrl.isEditing[0]"
                        on-update="$ctrl.updateMemberField(key, value)"
                        on-upload-complete="$ctrl.fetchMember($ctrl.member.id)">
                      </profile-fields>
                      <profile-actions
                        is-loading="$ctrl.isLoading"
                        ng-show="$ctrl.isEditing[0]"
                        on-cancel="$ctrl.onCancel($ctrl.member.id)">
                      </profile-actions>
                    </form>
                    <div class="d-flex justify-content-between justify-content-md-center"
                      ng-hide="$ctrl.isEditing[0]">
                      <button-link data-toggle="modal" data-target="#modalChangePassword">
                        Change Password
                      </button-link>
                      <modal target="modalChangePassword">
                        <modal-title>
                          <span class="text-center">Change Password</span>
                        </modal-title>
                        <modal-body>
                          <form class="voome-form"
                            name="form"
                            autocomplete="off"
                            ng-submit="$ctrl.updateMemberPassword($ctrl.member.id, form.data)"
                            novalidate>
                            <profile-fields-password
                              form="form"
                              is-update="true"
                              has-error="$ctrl.error"
                              message="$ctrl.message">
                            </profile-fields-password>
                            <div class="modal-footer pb-0 d-flex justify-content-center">
                              <button-primary
                                is-inverse="true"
                                data-dismiss="modal"
                                on-click="$ctrl.resetForm(form)">
                                Cancel
                              </button-primary>
                              <button-primary
                                ng-type="submit"
                                ng-disabled="form.$invalid">
                                <spinner is-loading="$ctrl.isLoading">
                                  Submit
                                </spinner>
                              </button-primary>
                            </div>
                          </form>
                        </modal-body>
                      </modal>
                      <span class="px-3 text-light"></span>
                      <button-link ng-click="$ctrl.authLogout()">
                        <i class="fa fa-sign-out"></i> Logout
                      </button-link>
                    </div>
                  </profile-container>
                </div>
                <div class="mb-3">
                  <profile-container
                    on-click="$ctrl.onToggleEditing(1)"
                    is-editing="$ctrl.isEditing[1]">
                    <form name="fieldsMoreForm"
                      ng-submit="$ctrl.onSubmit()"
                      novalidate>
                      <profile-fields-more
                        form="fieldsMoreForm"
                        member="$ctrl.member"
                        is-editing="$ctrl.isEditing[1]"
                        on-update="$ctrl.updateMemberField(key, value)">
                      </profile-fields-more>
                      <profile-actions
                        is-loading="$ctrl.isLoading"
                        ng-show="$ctrl.isEditing[1]"
                        on-cancel="$ctrl.onCancel($ctrl.member.id)">
                      </profile-actions>
                    </form>
                  </profile-container>
                </div>
                <div class="mb-3">
                  <profile-container
                    on-click="$ctrl.onToggleEditing(2)"
                    is-editing="$ctrl.isEditing[2]">
                    <form name="nutrititonForm"
                      ng-submit="$ctrl.onSubmit()"
                      novalidate>
                      <profile-fields-nutrition
                        form="nutrititonForm"
                        member="$ctrl.member"
                        is-editing="$ctrl.isEditing[2]"
                        questions="$ctrl.nutritionQuestions"
                        on-update="$ctrl.updateMemberField(key, value)">
                      </profile-fields-nutrition>
                      <profile-actions
                        is-loading="$ctrl.isLoading"
                        ng-show="$ctrl.isEditing[2]"
                        on-cancel="$ctrl.onCancel($ctrl.member.id)">
                      </profile-actions>
                    </form>
                  </profile-container>
                </div>
                <div class="mb-3" ng-if="$ctrl.workoutQuestions">
                  <profile-container
                    on-click="$ctrl.onToggleEditing(3)"
                    is-editing="$ctrl.isEditing[3]">
                    <form name="workoutForm"
                      ng-submit="$ctrl.onSubmit()"
                      novalidate>
                      <profile-fields-workout
                        form="workoutForm"
                        member="$ctrl.member"
                        is-editing="$ctrl.isEditing[3]"
                        questions="$ctrl.workoutQuestions"
                        on-update="$ctrl.updateMemberField(key, value)">
                      </profile-fields-workout>
                      <profile-actions
                        is-loading="$ctrl.isLoading"
                        ng-show="$ctrl.isEditing[3]"
                        on-cancel="$ctrl.onCancel($ctrl.member.id)">
                      </profile-actions>
                    </form>
                  </profile-container>
                </div>
                <profile-container
                  is-editing="true"
                  ng-switch="$ctrl.billing.type">
                  <profile-billing
                    ng-switch-when="history"
                    subscription="$ctrl.billing.subscription || $ctrl.subscription"
                    is-loading="$ctrl.isLoading"
                    subscriptions="$ctrl.subscriptions"
                    on-click-cancel="$ctrl.onToggleBilling('cancel', subscription)"
                    on-click-downgrade="$ctrl.onToggleBilling('downgrade', subscription)"
                    on-click-resume="$ctrl.resumeSubscription($ctrl.member.id, subscriptionId)">
                  </profile-billing>
                  <form novalidate
                    name="downgradeForm"
                    ng-switch-when="downgrade"
                    ng-submit="$ctrl.onDowngradeSubscription(
                      $ctrl.billing.subscription || $ctrl.subscription,
                      downgradeForm.data
                    )">
                    <profile-fields-downgrade
                      has-error="$ctrl.error && !$ctrl.isLoading"
                      message="$ctrl.message"
                      form="downgradeForm"
                      subscription="$ctrl.billing.subscription"
                      products="$ctrl.product.products">
                    </profile-fields-downgrade>
                    <profile-actions
                      is-loading="$ctrl.isLoading"
                      is-disabled="$ctrl.form.productId.$invalid"
                      on-cancel="$ctrl.onToggleBilling('history', $ctrl.billing.subscription)">
                    </profile-actions>
                  </form>
                  <form novalidate
                    name="cancelForm"
                    ng-switch-when="cancel"
                    ng-submit="$ctrl.onCancelSubscription(
                      $ctrl.member,
                      $ctrl.billing.subscription || $ctrl.subscription,
                      cancelForm.data
                    )">
                    <profile-fields-cancel
                      has-error="$ctrl.error && !$ctrl.isLoading"
                      message="$ctrl.message"
                      form="cancelForm"
                      reasons="$ctrl.billing.reasons"
                      subscription="$ctrl.billing.subscription">
                    </profile-fields-cancel>
                    <profile-actions
                      is-loading="$ctrl.isLoading"
                      is-disabled="$ctrl.form.reasonAnswer.$invalid || $ctrl.form.reasonPassword.$invalid"
                      on-cancel="$ctrl.onToggleBilling('history', $ctrl.billing.subscription)">
                    </profile-actions>
                  </form>
                </profile-container>
              </div>
            </div>
          </section>
        </div>
      </main>
      <modal
        target="modifySubscriptionModal"
        on-hidden="$ctrl.reload()">
        <modal-title>
          Subscription Modified
        </modal-title>
        <modal-body>
          <div class="text-center">
            <p>
              You have successfully modified your subscription to
              <br>
              {{ $ctrl.product.name }}
            </p>
            <p>
              <button-primary on-click="$ctrl.reload()">
                Continue
              </button-primary>
            </p>
          </div>
        </modal-body>
      </modal>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.isEditing = [false, false, false, false];
        this.billing = {
          reasons: PROFILE_CANCELLATION_REASONS,
          type: 'history',
        };

        if (!this.invoices) {
          const { memberId, voomeProductId } = memberStorage.get();
          this.fetchInvoices(memberId, voomeProductId);
        }

        // Ensure we have an upto date member
        this.fetchMember(memberStorage.get().memberId);

        // Check ability to update credit card.
        this.checkStatus();
      },

      $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },

      onSubmit() {
        this.updateMember(this.member);
        this.onToggleEditing();
      },

      onCancel(memberId) {
        this.fetchMember(memberId);
        this.onToggleEditing();
      },

      onToggleEditing(index) {
        this.isEditing = map(this.isEditing, (value, key) => {
          return key === index ? !value : false;
        });
      },

      onToggleBilling(type, subscription) {
        this.billing = {
          ...this.billing,
          type,
          subscription,
        };

        // Reset the update password form.
        this.reset();
      },

      onCancelSubscription(member, subscription, data) {
        const params = {
          reason: data.reasonOther ? data.reasonOther : data.reasonAnswer,
          password: data.reasonPassword,
        };

        this.cancelSubscription(member.id, subscription.id, params);
        this.onCancelSuccess(subscription.voomeProductId);
      },

      onCancelSuccess(voomeProductId) {
        this.unsubscribe = $ngRedux.subscribe(() => {
          const { member } = $ngRedux.getState();
          const subscription = selectSubscription(member, voomeProductId);

          if (subscription.status === 'delayed_cancelled') {
            this.unsubscribe();
            this.onToggleBilling('history', subscription);
          }
        });
      },

      onDowngradeSubscription(subscription, data) {
        const { id, voomeProductId } = subscription;
        this.onDowngradeSuccess(voomeProductId);
        this.downgradeSubscription(id, data.voomeProductId);
      },

      onDowngradeSuccess(voomeProductId) {
        this.unsubscribe = $ngRedux.subscribe(() => {
          const { member, signup } = $ngRedux.getState();
          const currentSubscription = selectSubscription(member);

          if (currentSubscription.voomeProductId !== voomeProductId) {
            this.unsubscribe();
            $('#modifySubscriptionModal').modal('show');
          }
        });
      },

      reload() {
        window.location.reload();
      },

      mapState({ member, signup }) {
        const nutritionQuestions = selectHasNutritionSubscription(member)
          ? selectNutritionQuestions(member)
          : undefined;

        const workoutQuestions = selectHasWorkoutSubscription(member)
          ? selectWorkoutQuestions(member)
          : undefined;

        const { isLoading, error, message } = member;
        const subscription = selectSubscription(member);

        return {
          nutritionQuestions,
          workoutQuestions,
          isLoading,
          error,
          message,
          subscription,
          member: selectMember(member),
          subscriptions: selectSubscriptions(member),
          product: selectProduct(signup, subscription.voomeProductId),
        };
      },

      mapDispatch() {
        return {
          authLogout,
          checkStatus,
          cancelSubscription,
          fetchMember,
          fetchInvoices,
          downgradeSubscription,
          reset,
          resumeSubscription,
          selectNutritionQuestions,
          setup,
          updateChargifyData,
          updateMember,
          updateMemberPassword,
          updateMemberField,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Profile.js